export default {
    methods: {
        handlerFilter() {
            this.getData()
        },
        handlerCleanFilter() {
            console.info('ready to clean the filter')
        },
        changeClient(e) {
            this.client = { key: e.key, label: e.label }
        },
        async getData() {
            const params = {
                page: 1,
                limit: 10000,
                order: {
                    _EntityId: 'desc',
                },
                filters: [
                    {
                        _ParentOperator: 'AND',
                        _Operator: 'AND',
                        Fields: {
                            // date: {
                            //     type: 'date',
                            //     from,
                            //     to,
                            // },
                        },
                    },
                ],
            }
            // if (this.selectedYears.length) {
            //     params.filters[0].Fields.date = {
            //         type: 'date',
            //         from,
            //         to,
            //     }
            // }
            if (this.client.key) {
                params.filters[0].Fields.client = {
                    type: 'number',
                    value: this.client.key,
                    lig: '=',
                }
            }
            const res = await this.$gestios.items('bills').list(params)
            if (res.ok) {
                // total Invert
                this.details[0].value = res.data.reduce((acc, cvv) => acc + cvv.subtotal, 0)
                this.details[0].series = [
                    { ...this.details[0].series[0], data: res.data.flatMap((item) => item.subtotal) },
                ]

                // total Profit
                this.details[1].value = res.data.reduce((acc, cvv) => acc + cvv.total + cvv.surcharge, 0)
                this.details[1].series = [
                    { ...this.details[1].series[0], data: res.data.map((item) => item.total + item.surcharge) },
                ]

                // total Spent
                this.details[2].value = res.data.reduce((acc, cvv) => acc + cvv.surcharge, 0)
                this.details[2].series = [
                    { ...this.details[2].series[0], data: res.data.flatMap((item) => item.surcharge) },
                ]

                // IVA
                this.details[3].value = res.data.reduce((acc, cvv) => acc + cvv.iva, 0)
                this.details[3].series = [{ ...this.details[3].series[0], data: res.data.flatMap((item) => item.iva) }]

                // Top
                this.setTop(res.data.flatMap((item) => item.concepts))
            }
        },
        setTop(data) {
            const top = Object.values(
                data.reduce((acc, cvv) => {
                    const key = cvv.text
                    if (!acc[key]) {
                        acc[key] = {
                            ...cvv,
                            quantity: 0,
                        }
                    }
                    acc[key].quantity += cvv.quantity
                    return acc
                }, {})
            )
            this.topSellerOptions = {
                ...this.topSellerOptions,
                labels: top.map((item) => item.text),
            }
            this.topSellerSeries = top.map((item) => item.quantity)
            const totalQuantity = top.reduce((acc, item) => acc + item.quantity, 0)

            this.topSalesData = top
                .sort((a, b) => b.quantity - a.quantity)
                .map((item) => ({
                    product: item.text,
                    value: item.quantity,
                    percentage: ((item.quantity / totalQuantity) * 100).toFixed(2),
                    top: true,
                    // top: index <= 2,
                }))
        },
    },
}
